import React from "react";
import { FaEye, FaEyeSlash, FaPen, FaRedo } from "react-icons/fa";

const Legendes = () => {
  return (
    <>
      <div className="parametres_site__container__content__right__item">
        <FaEye size={"2em"} /> Votre module est visible dans la barre de
        navigation
      </div>
      <div className="parametres_site__container__content__right__item">
        <FaEyeSlash size={"2em"} /> Votre module est invisible dans la barre de
        navigation
      </div>
      <div className="parametres_site__container__content__right__item">
        <FaRedo size={"2em"} className="small" />
        Réinitialiser les paramètres par défaut
      </div>
      <div className="parametres_site__container__content__right__item">
        <FaPen size={"2em"} className="small" />
        Renommer mon module
      </div>
    </>
  );
};

export default Legendes;
